import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BUSINESS_MODULES } from '../../constants/businessModules';

const ModulePlaceholderPage: React.FC = () => {
  const navigate = useNavigate();
  const { moduleKey } = useParams<{ moduleKey: string }>();
  const current = BUSINESS_MODULES.find((item) => item.key === moduleKey);

  const handleBack = () => {
    navigate('/dashboard/select-module');
  };

  if (!current) {
    return (
      <div className="min-h-screen bg-gray-50 px-6 py-12">
        <div className="mx-auto max-w-2xl rounded-xl border border-red-200 bg-white p-8 shadow-sm">
          <h1 className="text-xl font-semibold text-red-600">无效的业务板块</h1>
          <p className="mt-3 text-sm text-gray-600">请返回业务板块选择页重新选择。</p>
          <div className="mt-6">
            <button
              type="button"
              onClick={handleBack}
              className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
            >
              返回选择页
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-12">
      <div className="mx-auto max-w-3xl rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-semibold text-gray-900">{current.label}</h1>
        <p className="mt-3 text-sm text-gray-600">该服务板块未上线,无法使用管理后台.</p>

        <div className="mt-8 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={handleBack}
            className="rounded border border-blue-300 px-4 py-2 text-sm font-medium text-blue-700 hover:bg-blue-50"
          >
            选择其他服务板块
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModulePlaceholderPage;

